import { useCallback } from 'react';
import { useGetHasProductV2, useHasAnyWohnenPlus } from './useGetHasProduct.hook';
import { ProductType } from '@/@types/product';
import { report } from '@/tracking/tracking';
import { TrackingEvent } from '@/@types/trackingEvent';

export const useReportTrackingTenant = () => {
  const { isLoading = false } = useGetHasProductV2(ProductType.WohnenPlus) || {};
  const hasWohnenPlus = useHasAnyWohnenPlus();

  const reportTenantTracking = useCallback(
    (event: TrackingEvent) => {
      if (isLoading) return;
      report(event, hasWohnenPlus);
    },
    [hasWohnenPlus, isLoading],
  );

  return {
    reportTenantTracking,
  };
};
